import React, { useState, useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';

// TODO: Crear componente CreateAppointmentModal
// Ubicación: src/components/AppointmentManagement/Popup/CreateAppointmentModal.js
// Props esperadas: { show, handleClose, onSave }
// Propósito: Modal para crear nuevas citas con formulario completo
import CreateAppointment from '../Popup/CreateAppointment';

// TODO: Crear componente AppointmentFilter
// Ubicación: src/components/AppointmentManagement/Buttons/AppointmentFilter.js
// Props esperadas: { initialFilters, onFilterChange }
// Propósito: Componente de filtros avanzados para citas
import AppointmentFilter from '../Buttons/AppointmentFilter';

// TODO: Crear componente AppointmentActionButton
// Ubicación: src/components/AppointmentManagement/Buttons/AppointmentActionButton.js
// Props esperadas: { selectedAppointments, onBulkDelete }
// Propósito: Botón con acciones masivas (eliminar, exportar, etc.)
import ActionButton from '../Buttons/AppointmentActionButton';

// TODO: Crear componente UniversalSearch
// Ubicación: src/components/AppointmentManagement/Buttons/UniversalSearch.js
// Props esperadas: { onSearch, placeholder }
// Propósito: Barra de búsqueda universal con funcionalidad de autocompletado
import UniversalSearch from '../Buttons/UniversalSearch';

const AppointmentFiltersHeader = ({ 
  onFilterChange,        // Función callback para cambios en filtros
  onSearchChange,        // Función callback para cambios en búsqueda
  selectedAppointments = [], // Array de citas seleccionadas
  onClearSelection,      // Función para limpiar selección
  onBulkDelete = () => {}, // Función para eliminación masiva
  onReloadData = () => {} // Función para recargar todos los datos
}) => {
  // Estado para todos los filtros disponibles
  const [currentFilters, setCurrentFilters] = useState({
    id: '',
    appointmentId: '',
    patientName: '',
    patientAvatar: '',
    dateOfBirth: '',
    address: '',
    userid: '',
    meetinguserid: '',
    doctorName: '',
    doctorRole: '',
    date: '',
    startTime: '',
    endTime: '',
    status: '',
    medicalHistory: '',
    appointmentType: '',
    notes: '',
    checkInTime: '',
    waitTime: '',
    consultationDuration: '',
    isaccepted: '',
    createdAt: '',
    updatedAt: '',
    searchName: ''
  });

  // Estado para los filtros activos (que tienen valores)
  const [activeFilters, setActiveFilters] = useState([]);
  
  // Estado para mostrar/ocultar la sección de filtros activos
  const [showActiveFilters, setShowActiveFilters] = useState(true);
  
  // Estado para mostrar/ocultar el modal de creación
  const [showModal, setShowModal] = useState(false);
  
  // Estado para mostrar/ocultar el sidebar de filtros
  const [showFilterSidebar, setShowFilterSidebar] = useState(false);

  // Ref para el sidebar de filtros
  const sidebarRef = useRef(null);

  // Función para convertir objeto de filtros a array para mostrar
  const convertFiltersToArray = (filters) => {
    return Object.entries(filters)
      .filter(([, value]) => value !== '') // Solo filtros con valores
      .map(([label, value]) => ({ 
        label: label.charAt(0).toUpperCase() + label.slice(1), // Capitalizar primera letra
        value, 
        key: label 
      }));
  };

  // Maneja cambios en los filtros
  const handleFilterChange = (filters) => {
    setCurrentFilters(filters);
    
    // Actualiza los filtros activos
    const newActiveFilters = convertFiltersToArray(filters);
    setActiveFilters(newActiveFilters);
    
    // Notifica al componente padre
    onFilterChange(filters);
  };

  // Maneja la búsqueda universal
  const handleUniversalSearch = (searchTerm) => {
    const updatedFilters = { 
      ...currentFilters, 
      searchName: searchTerm 
    };
    
    setCurrentFilters(updatedFilters);
    
    // Actualiza los filtros activos
    const newActiveFilters = convertFiltersToArray(updatedFilters);
    setActiveFilters(newActiveFilters);

    // Notifica al componente padre
    onSearchChange(searchTerm);
  };

  // Remueve un filtro específico
  const removeFilter = (filterToRemove) => {
    const updatedFilters = { ...currentFilters };
    
    // Limpia el valor del filtro
    updatedFilters[filterToRemove.key] = '';
    
    setCurrentFilters(updatedFilters);
    
    // Actualiza los filtros activos
    const newActiveFilters = convertFiltersToArray(updatedFilters);
    setActiveFilters(newActiveFilters);
    
    // Notifica al componente padre
    onFilterChange(updatedFilters);
    
    // Si no quedan filtros activos, recarga todos los datos
    if (newActiveFilters.length === 0) {
      onReloadData();
    }
  };

  // Limpia todos los filtros
  const clearAllFilters = () => {
    const resetFilters = {
      id: '',
      appointmentId: '',
      patientName: '',
      patientAvatar: '',
      dateOfBirth: '',
      address: '',
      userid: '',
      meetinguserid: '',
      doctorName: '',
      doctorRole: '',
      date: '',
      startTime: '',
      endTime: '',
      status: '',
      medicalHistory: '',
      appointmentType: '',
      notes: '',
      checkInTime: '',
      waitTime: '',
      consultationDuration: '',
      isaccepted: '',
      createdAt: '',
      updatedAt: '',
      searchName: ''
    };

    setCurrentFilters(resetFilters);
    setActiveFilters([]);
    onFilterChange(resetFilters);
    
    // Limpia las selecciones si existe la función
    if (onClearSelection) {
      onClearSelection();
    }
    
    // Recarga todos los datos
    onReloadData();
  };

  // Abre el modal de creación
  const handleOpenModal = () => {
    setShowModal(true);
  };

  // Cierra el modal de creación
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Maneja el guardado de nueva cita
  const handleSaveAppointment = (appointmentData) => {
    console.log('Appointment Data:', appointmentData);
    // TODO: Implementar lógica de guardado real
    
    // Cierra el modal después de guardar
    setShowModal(false);
  };

  // Toggle para mostrar/ocultar filtros activos
  const toggleActiveFiltersVisibility = () => {
    setShowActiveFilters(!showActiveFilters);
  };

  // Toggle para mostrar/ocultar sidebar de filtros
  const toggleFilterSidebar = () => {
    setShowFilterSidebar(!showFilterSidebar);
  };

  // Combina filtros activos con citas seleccionadas
  const allActiveFilters = [
    ...activeFilters,
    ...(selectedAppointments.length > 0 
      ? [{ 
          label: 'Appt. Selected', 
          value: selectedAppointments.length, 
          key: 'selectedAppointments' 
        }] 
      : [])
  ];

  // Efecto para manejar clic fuera del sidebar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showFilterSidebar &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        // Verificar si el clic fue en el botón de filtros
        const filterButton = event.target.closest('[data-filter-button]');
        if (!filterButton) {
          setShowFilterSidebar(false);
        }
      }
    };

    // Agregar event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterSidebar]);

  // Efecto para manejar tecla Escape
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        if (showFilterSidebar) {
          setShowFilterSidebar(false);
        }
        if (showModal) {
          setShowModal(false);
        }
      }
    };

    // Agregar event listener
    document.addEventListener('keydown', handleEscapeKey);
    
    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [showFilterSidebar, showModal]);

  return (
    <>     
      {/* Header principal con búsqueda y botones */}
      <div className="filter-container py-3">
        <div className="row align-items-center">
          <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
            <UniversalSearch 
              onSearch={handleUniversalSearch}
              placeholder="Search appointments..."
            />
          </div>

          {/* Botones de acción */}
          <div className="col-md-7 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2 gy-3 flex-wrap">
            {/* Botón de acciones masivas */}
              <ActionButton 
                selectedAppointments={selectedAppointments}
                onBulkDelete={onBulkDelete}
              /> 

            {/* Filter button */}
              <Link 
                to="#" 
                className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative"
                type="button"
                onClick={toggleFilterSidebar}
              >
                <div className="filter_text d-flex align-items-center gap-1">
                                                        <span className="d-block material-symbols-outlined icon-md">tune</span>
                                                        <span className="d-block">Filter</span>
                                                    </div>
                {/* Show badge only if there are active filters */}
                {allActiveFilters.length > 0 && (
                  <span 
                    className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary" 
                    style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
                  >
                    {allActiveFilters.length}
                  </span>
                )}
              </Link>

            {/* Botón para crear nueva cita */}
            
              {/* Modal de creación */}
      <CreateAppointment
      />
            
          </div>
        </div>
      </div>

      {/* Overlay para cerrar sidebar */}
      {showFilterSidebar && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
          style={{zIndex: 1040}}
          onClick={toggleFilterSidebar}
        />
      )}

      {/* Sidebar de filtros */}
      {showFilterSidebar && (
        <div 
          ref={sidebarRef}
          className="position-fixed top-0 end-0 h-100 bg-white shadow" 
          style={{width: '350px', zIndex: 1050, overflowY: 'auto'}}
        >
          <div className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Filters of Appointments</h5>
              <button 
                className="btn btn-close" 
                onClick={toggleFilterSidebar}
                aria-label="Close filters"
              ></button>
            </div>
            <AppointmentFilter 
              initialFilters={currentFilters}
              onFilterChange={handleFilterChange}
            />
          </div>
        </div>
      )}

      

      {/* Sección de filtros activos */}
      {showActiveFilters && allActiveFilters.length > 0 && (
        <div className="container-fluid mb-3 mt-3 border">
          <div className="row align-items-center">
            <div className="col-auto">
              <span className="text-muted me-2">Active Filters:</span>
              {/* Renderiza cada filtro activo como badge */}
              {allActiveFilters.map((filter, index) => (
                <span 
                  key={index} 
                  className="badge bg-light text-dark me-2 d-inline-flex align-items-center"
                >
                  {filter.label}: {filter.value}
                  {/* Botón para remover filtro individual */}
                  <button 
                    className="btn btn-sm btn-link p-0 ms-2"
                    onClick={() => {
                      if (filter.key === 'selectedAppointments') {
                        // Si es el filtro de selección, limpia la selección
                        onClearSelection && onClearSelection();
                      } else {
                        // Si es un filtro normal, lo remueve
                        removeFilter(filter);
                      }
                    }}
                    aria-label={`Remove ${filter.label} filter`}
                  >
                    ✕
                  </button>
                </span>
              ))}
            </div>
            {/* Botón para limpiar todos los filtros */}
            <div className="col-auto ms-auto">
              {allActiveFilters.length > 0 && (
                <button 
                  className="btn btn-link text-primary"
                  onClick={clearAllFilters}
                >
                  Clear All
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AppointmentFiltersHeader;